import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! TelecallerUser APIs
export const addTeleCallerUserAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}create-telecaller-user`,   data,  headers);
};

export const getTeleCallerUserListAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}get-telecaller-user-list`,   data,  headers);
};

export const updateTeleCallerUserAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-telecaller-user`,   data,  headers);
};

export const updateStatusTellecaller = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}update-telecaller-user-status`,   data,  headers);
};
export const tellecallerDashBoard = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}telecaller-dashboard`,   data,  headers);
};
export const prescriptionList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}prescription-list`,   data,  headers);
};
export const uploadCart = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}bulk-upload-cart`,   data,  headers);
};
export const prescriptionStatus = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}prescription-status`,   data,  headers);
};